module.exports = __webpack_public_path__ + "img/ella.b3be42b2.png";